var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';
export default (function (props) {
  return React.createElement(SvgIcon, _extends({
    viewBox: '0 0 32 38'
  }, props), React.createElement('path', {
    d: 'M22.848 11.424h-18.304v-4.576h18.304v4.576zM34.272 27.424v2.304h-36.544v-27.456h2.272v25.152h34.272zM18.272 18.272h-13.728v-4.544h13.728v4.544zM25.12 25.152h-20.576v-4.576h20.576v4.576z'
  }));
});